import React, { useState } from 'react';
import StatusBadge from './StatusBadge';

function formatValue(key, value) {
  if (value === null || value === undefined) return '—';
  if (React.isValidElement(value)) return value;
  if (key.includes('time') || key.includes('_at') || key === 'day' || key === 'next_run') {
    try {
      return new Date(value).toLocaleString('it-IT');
    } catch { return value; }
  }
  if (key === 'status') return <StatusBadge status={value} />;
  if (typeof value === 'boolean') return value ? '✅' : '❌';
  if (key.includes('_gb') || key.includes('_percent')) {
    return typeof value === 'number' ? value.toFixed(1) : value;
  }
  return String(value);
}

export default function DataTable({ title, columns, rows, emptyMsg = 'Nessun dato' }) {
  const [sortCol, setSortCol] = useState(null);
  const [sortDir, setSortDir] = useState('asc');

  const handleSort = (col) => {
    if (sortCol === col) setSortDir(d => d === 'asc' ? 'desc' : 'asc');
    else { setSortCol(col); setSortDir('asc'); }
  };

  const sorted = sortCol
    ? [...(rows || [])].sort((a, b) => {
        const av = a[sortCol], bv = b[sortCol];
        if (av == null) return 1;
        if (bv == null) return -1;
        return sortDir === 'asc'
          ? String(av).localeCompare(String(bv), undefined, { numeric: true })
          : String(bv).localeCompare(String(av), undefined, { numeric: true });
      })
    : (rows || []);

  return (
    <div style={s.card}>
      {title && <div style={s.title}>{title}</div>}
      {!rows || rows.length === 0 ? (
        <div style={s.empty}>{emptyMsg}</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={s.table}>
            <thead>
              <tr>
                {columns.map(col => (
                  <th
                    key={col.key}
                    onClick={() => handleSort(col.key)}
                    style={{ ...s.th, cursor: 'pointer', userSelect: 'none' }}
                  >
                    {col.label}
                    {sortCol === col.key ? (sortDir === 'asc' ? ' ↑' : ' ↓') : ''}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sorted.map((row, i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                  {columns.map(col => (
                    <td
                      key={col.key}
                      style={{ ...s.td, ...(col.key === 'retention_summary' && row.retention_detail ? { cursor: 'help', borderBottom: '1px dotted #94a3b8' } : {}) }}
                      title={col.key === 'retention_summary' ? (row.retention_detail || undefined) : undefined}
                    >
                      {formatValue(col.key, row[col.key])}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

const s = {
  card:  { background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', marginBottom: 20, overflow: 'hidden' },
  title: { padding: '14px 20px', fontWeight: 700, fontSize: 15, color: '#1e293b', borderBottom: '1px solid #f1f5f9' },
  empty: { padding: '32px', textAlign: 'center', color: '#94a3b8', fontSize: 14 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th:    { padding: '10px 16px', background: '#f8fafc', color: '#64748b', fontWeight: 600, textAlign: 'left', borderBottom: '1px solid #e2e8f0', whiteSpace: 'nowrap' },
  td:    { padding: '10px 16px', color: '#334155', borderBottom: '1px solid #f1f5f9', whiteSpace: 'nowrap' },
};
